import type { CSSProperties } from 'react'

/** Shared art for Start / Claim primary actions */
export const ACTION_PLATE_BUTTON_BG = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/redesign/button.webp'

/** Shared art for Cancel actions */
export const CANCEL_BUTTON_BG = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/redesign/cancel-btn.webp'

/** Shared art for Immediate (ECS skip) actions */
export const IMMEDIATE_BUTTON_BG = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/redesign/immediate-btn.webp'

/** Background image + no border; dims when disabled */
export function getStartClaimPlateStyle(disabled: boolean, extra?: CSSProperties): CSSProperties {
  return {
    backgroundImage: `url(${ACTION_PLATE_BUTTON_BG})`,
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    opacity: disabled ? '70%' : '100%',
    // boxShadow: disabled ? 'none' : '0 4px 14px rgba(0,0,0,0.22)',
    ...extra,
  }
}

/** Immediate plate: `immediate-btn.png`, no border */
export function getImmediatePlateStyle(disabled: boolean, extra?: CSSProperties): CSSProperties {
  return {
    backgroundImage: disabled
      ? `linear-gradient(rgba(0,0,0,0.42), rgba(0,0,0,0.42)), url(${IMMEDIATE_BUTTON_BG})`
      : `url(${IMMEDIATE_BUTTON_BG})`,
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    ...extra,
  }
}

/** Cancel plate: `cancel-btn.png`, no border */
export function getCancelPlateStyle(disabled: boolean, extra?: CSSProperties): CSSProperties {
  return {
    backgroundImage: disabled
      ? `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${CANCEL_BUTTON_BG})`
      : `url(${CANCEL_BUTTON_BG})`,
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    ...extra,
  }
}
